import React, { useState, useEffect } from "react";
import { Col, Row, Image, InputGroup, Form } from "react-bootstrap";
import Card from "../../../components/card/AdminCard";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import {
  GetLearningModule,
  selectLearningModule,
} from "../../../features/learning/learningModuleSlice";
import {
  GetCounsellorModule,
  selectCounsellorModule,
} from "../../../features/learning/CounsellorSlice";

import Search from "../../../assets/images/search-line.svg";
import Back from "../../../assets/images/ic-arrow-back.svg";
import EmptyRow from "../../../components/emptyRow/EmptyRow";
import Feedback from "../../../components/feedbackNote/Feedback";

const title: String = "";
const title2: String = "Ethics Counsellor Learning Program";

const LearningModulesEditDetails = () => {
  const LearingModule = useAppSelector(selectLearningModule);
  const CounsellorModule = useAppSelector(selectCounsellorModule);
  const dispatch = useAppDispatch();
  //console.log('LearingModule',LearingModule)
  const userDetails = localStorage.getItem("userDetails");
  const userDetailsList: any = userDetails;
  const userDetailsJson = JSON.parse(userDetailsList);

  useEffect(() => {
    var data = {
      keyword: "",
      offset: 0,
      companyId: userDetailsJson.companyId,
    };
    async function fetchLearningModuleData() {
      let sample = await dispatch(GetLearningModule(data));
    }

    async function fetchConsellerModuleData() {
      let sample = await dispatch(GetCounsellorModule(data));
    }
    fetchLearningModuleData();
    fetchConsellerModuleData();
  }, []);

  const [searchData, setsearchData] = useState("");
  const searchItems = async (searchValue: any) => {
    await setsearchData(searchValue);
    var data = {
      keyword: searchData,
      offset: 0,
      companyId: userDetailsJson.companyId,
    };
    await dispatch(GetLearningModule(data));
    await dispatch(GetCounsellorModule(data));
  };

  const rowLearnArrayData = LearingModule?.slice(0, 4);
  const Learnlist: any = rowLearnArrayData;

  const rowConsellArrayData = CounsellorModule?.slice(0, 4);
  const consellList: any = rowConsellArrayData;
  const fetchLearningModuleData = () => {
    var data = {
      keyword: "",
      offset: 0,
      companyId: userDetailsJson.companyId,
    };
    dispatch(GetLearningModule(data));
  };
  return (
    <>
      <Feedback pageName="Learning And Awarness" />
      <Row>
        <Col sm={12}>
          <a href="/learningmodulesDetails">
            <span style={styles.backstyle}>
              <Image src={Back} />
              Back{" "}
            </span>
          </a>
        </Col>
      </Row>
      <EmptyRow />

      <Row>
        <Col sm={8}>
          <h4>Learning Modules</h4>
        </Col>

        <Col sm={4}>
          <InputGroup
            className="border bg-white"
            style={{ border: "solid 1px #e4e4e4" }}
          >
            <Image
              style={styles.image1}
              className="d-inline border-0 my-auto mx-2"
              src={Search}
              fluid
            />
            <Form.Control
              onChange={(e) => searchItems(e.target.value)}
              name={searchData}
              className="border-0 shadow-none ps-0"
              style={styles.text1}
              type="text"
              placeholder="Search"
            />
          </InputGroup>
        </Col>
      </Row>

      <EmptyRow />

      <div style={{ marginBottom: "20px" }}>
        <Card
          type={1}
          title={title}
          data={LearingModule}
          moduleid={1}
          fetchLearningModuleData={fetchLearningModuleData}
          modal={
            <>
              {/* <LearningModulesModal title="Learning Modules" records={LearingModule}/> */}
              {/* <LearningModulesEdit data={LearingModule}/> */}
            </>
          }
        />
      </div>
    </>
  );
};

const styles: any = {
  editstyle: {
    color: "#e31837",
    fontFamily: "Saira",
    fontWeight: 600,
    fontSize: "12px",
    float: "right",
    marginTop: "10px",
  },

  backstyle: {
    color: "#e31837",
    fontFamily: "Saira",
    fontWeight: 600,
    fontSize: "12px",
    marginTop: "10px",
  },
};

export default LearningModulesEditDetails;
